/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationSignpostRightIcon24Solid = forwardRef('LocationSignpostRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.5 2.5a1.5 1.5 0 0 0-3 0V4h-6A2.5 2.5 0 0 0 2 6.5v5A2.5 2.5 0 0 0 4.5 14h6v7.5a1.5 1.5 0 1 0 3 0V14h4.387a2.5 2.5 0 0 0 1.858-.828l3.002-3.336a1.25 1.25 0 0 0 0-1.672l-3.002-3.336A2.5 2.5 0 0 0 17.887 4H13.5V2.5Z" })));
});
